// src/baseUrl.js

let BASE_URL = ''

switch (process.env.NODE_ENV) {
  case 'development':
  case 'eduslim':
    BASE_URL = 'https://test-doatap.minedu.gov.gr/laravel/public/api'
    // BASE_URL = 'https://eduslim1.minedu.gov.gr/laravel/public/api'
    break
  case 'dev-vimasrv001':
  case 'vimasrv001':
    // BASE_URL = 'http://vimasrv001.minedu.gov.gr:8080/api'
    BASE_URL = 'http://vimasrv012.minedu.gov.gr:8999/api'
    break
  case 'dev-vimasrv002':
  case 'vimasrv002':
    // BASE_URL = 'http://vimasrv002.minedu.gov.gr:8801/api'
    // BASE_URL = 'http://vimasrv002.minedu.gov.gr:8851/api'
    // BASE_URL = 'http://vimasrv002.minedu.gov.gr:8901/api'
    BASE_URL = 'http://vimasrv002.minedu.gov.gr:7000/api' // Maria, since 2025-09-03
    // BASE_URL = 'http://vimasrv002.minedu.gov.gr:7500/api' // Panagiotis
    // BASE_URL = 'http://83.212.170.136:7500/api' // Panagiotis
    break
  case 'production':
  default:
    BASE_URL = 'https://e-doatap.doatap.gr/laravel/public/api'
    break
}

export { BASE_URL }



// WEBPACK FOOTER //
// ./src/baseUrl.js